import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    demoSubjectFinished: {
    },
    demoSubjectAnswers: [],
    demoCountFinished: 0,
    demoResults: {},
  },
  mutations: {
    finishSection(state, finishedSection) {
      state.demoSubjectFinished = Object.assign(state.demoSubjectFinished, finishedSection);
      state.demoCountFinished += 1;
    },
    submitAnswers(state, payload) {
      state.demoSubjectAnswers[payload.subjectOrder] = payload.subjectAnswers;
      // [].push.apply(state.demoSubjectAnswers, answers);
    },
    clearDemoData(state) {
      state.demoSubjectFinished = {};
      state.demoSubjectAnswers = [];
      state.demoCountFinished = 0;
      this.demoResults = {};
    },
    submitResults(state, results) {
      state.demoResults = results;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js